import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("schok_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// Normalize FastAPI/Pydantic errors so `detail` is ALWAYS a string.
// (422 responses return detail as an array of error objects which would crash React if rendered.)
api.interceptors.response.use(
  (res) => res,
  (error) => {
    const d = error?.response?.data?.detail;
    if (Array.isArray(d)) {
      error.response.data.detail =
        d.map((x) => (typeof x === "string" ? x : x?.msg?.replace(/^Value error, /, ""))).filter(Boolean).join(", ") || "Request failed";
    } else if (d && typeof d === "object") {
      error.response.data.detail = d.msg || "Request failed";
    }
    return Promise.reject(error);
  }
);

export const inr = (n) => {
  const v = Math.round(Number(n || 0) * 100) / 100;
  return `₹${v.toLocaleString("en-IN", Number.isInteger(v) ? { maximumFractionDigits: 0 } : { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const PIECE_OPTIONS = ["4", "6", "12", "16", "18", "24"];

export const TIER_ORDER = ["4", "6", "12", "16", "18", "24", "100g", "200g", "1"];
export const TIER_LABELS = {
  "4": "4 pcs", "6": "6 pcs", "12": "12 pcs", "16": "16 pcs", "18": "18 pcs", "24": "24 pcs",
  "100g": "100 g", "200g": "200 g", "1": "Single",
};
export const sortedTiers = (prices) =>
  Object.keys(prices || {}).sort((a, b) => TIER_ORDER.indexOf(a) - TIER_ORDER.indexOf(b));
export const tierLabel = (k) => TIER_LABELS[k] || k;

export const tierDiscount = (product, tier) => Number(product.tier_discounts?.[tier] || 0);
export const salePrice = (product, tier) =>
  Math.round(product.prices[tier] * (1 - tierDiscount(product, tier) / 100) * 100) / 100;
